import Header from "../../components/Menu";
import { Criativo } from "../../components/Criativo";

const CriativoPage = () => {
  return (
    <div className="flex">
      <Header />
      <Criativo />
    </div>
  );
};

export default CriativoPage;
